import { Routes } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { AccountCreatedComponent } from './components/pages/account-created/account-created.component';
import { ActivityBookingPageComponent } from './components/pages/activity-booking-page/activity-booking-page.component';
import { AdminPageComponent } from './components/pages/admin-page/admin-page.component';
import { CustomerPageComponent } from './components/pages/customer-page/customer-page.component';
import { CompanyAdminPageComponent } from './components/pages/company-admin-page/company-admin-page.component';
import { StorePageComponent } from './components/pages/store-page/store-page.component';
import { ActivityArchivePageComponent } from './components/pages/activity-archive-page/activity-archive-page.component';
import { AuthGuard } from './guards/auth.guard';

/**
 * Application routes configuration
 * Modern standalone approach with lazy loading support
 */
export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'Home'
  },
  {
    path: 'account-created',
    component: AccountCreatedComponent,
    title: 'Account Created'
  },
  {
    path: 'admin',
    component: AdminPageComponent,
    title: 'Admin',
    canActivate: [AuthGuard],
    data: { requiredGroups: ['admin'] }
  },
  {
    path: 'customer',
    component: CustomerPageComponent,
    title: 'Customer Dashboard',
    canActivate: [AuthGuard],
    data: { requiredGroups: ['customer', 'company', 'hotel', 'admin'] }
  },
  {
    path: 'backoffice',
    component: CompanyAdminPageComponent,
    data: { title: 'Backoffice', requiredGroups: ['company', 'admin'], tab: 'dashboard' },
    title: 'Backoffice',
    canActivate: [AuthGuard]
  },
  {
    path: 'backoffice/all-stores',
    component: CompanyAdminPageComponent,
    data: { title: 'Backoffice - All Stores', requiredGroups: ['company', 'admin'], tab: 'stores' },
    title: 'Backoffice - All Stores',
    canActivate: [AuthGuard]
  },
  {
    path: 'store/:id',
    component: StorePageComponent,
    title: 'Store'
  },
  {
    path: 'activity-archive',
    component: ActivityArchivePageComponent,
    title: 'Activity Archive',
    canActivate: [AuthGuard],
    data: { requiredGroups: ['company', 'admin'] }
  },
  {
    path: 'booking/:id',
    component: ActivityBookingPageComponent,
    title: 'Book Activity'
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
